import { isNumericString } from '../../../../utils/helper/helper_string';
export class Parse {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get comparer() {
        return this.parent;
    }
    get isRegex() {
        return false;
    }
    get isCleanedExpectedStringANumber() {
        return isNumericString(this.comparer.cleanedExpectedInput);
    }
    get isRawExpectedStringANumber() {
        return isNumericString(this.comparer.rawExpectedInput);
    }
}
